import { useEffect, useState } from "react";
import api from "@/api";

// Cached across mounts so we don't hit /api/config/public more than
// once per session.
let _cache = null;
let _inflight = null;

/**
 * Public runtime config from the backend.
 *
 *   { migration_ui_enabled: bool, is_production: bool, ready: bool }
 *
 * Safe defaults are returned until the fetch resolves — `ready:false`
 * lets callers decide whether to short-circuit gated UI.
 */
export default function usePublicConfig() {
  const [cfg, setCfg] = useState(_cache || {
    migration_ui_enabled: true,
    is_production: false,
    ready: !!_cache,
  });

  useEffect(() => {
    if (_cache) { setCfg({ ..._cache, ready: true }); return; }
    if (!_inflight) {
      _inflight = api.get("/config/public")
        .then(r => { _cache = r.data; return r.data; })
        .catch(() => ({ migration_ui_enabled: true, is_production: false }));
    }
    let mounted = true;
    _inflight.then(data => { if (mounted) setCfg({ ...data, ready: true }); });
    return () => { mounted = false; };
  }, []);

  return cfg;
}
